import { render, staticRenderFns } from "./BlackListMg.vue?vue&type=template&id=381af594&scoped=true"
import script from "./BlackListMg.vue?vue&type=script&lang=js"
export * from "./BlackListMg.vue?vue&type=script&lang=js"
import style0 from "./BlackListMg.vue?vue&type=style&index=0&id=381af594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381af594",
  null
  
)

export default component.exports